module.exports = __webpack_public_path__ + "img/header-video-bg-2-mob.09987138.webp";